import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.values.js";
import { isIdType } from 'types/utils';
function defaultGetItemId(item) {
  if (!isIdType(item)) {
    throw Error('uniq: Could not retrieve item ID');
  }
  return item;
}

/**
 * Remove duplicate items from an array.
 */

function uniq(
/**
 * Array of items to be de-duplicated
 */
items) {
  var getItemId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultGetItemId;
  var o = {};
  items.forEach(function (item) {
    var s = getItemId(item);
    if (!(s in o)) {
      o[s] = item;
    }
  });
  return Object.values(o);
}
export default uniq;